import products from "../data/products.json";
import {GenerateImagePath} from "../services/GenerateImagePath";
import React, {useCallback, useState} from "react";
export default function Productlist() {
    const [showLoaded, setShowLoaded] = useState(true);
    const [failedItems, setFailedItems] = useState(new Set());
    const [imageSize, setImageSize] = useState(50);

    let products_de = false;
    try {
        products_de = require('../data/products_de.json');
        const first_product_artnr = products_de[0].Artikelnummer;
        console.log('products_de imported. First Artikelnummer', first_product_artnr);
    } catch (e) {
        products_de = products;
        console.log('products_de fallback to products.json');
    }
    console.log('productlist', products_de);

    const handleImageError = useCallback((id) => {
        setFailedItems((prevSet) => {
            if (prevSet.has(id)) return prevSet; // Already registered
            const newSet = new Set(prevSet);
            newSet.add(id);
            return newSet;
        });
    }, []);

    if (!products_de || products_de.length === 0) {
        return <div>Loading products or no data found...</div>;
    }

    const thStyle = {
        padding: '14px 16px',
        backgroundColor: '#f7fafc',
        color: '#4a5568',
        fontWeight: '600',
        textAlign: 'left',
        fontSize: '13px',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        borderBottom: '2px solid #e2e8f0',
    };

    return (
        <div style={{
            fontFamily: 'system-ui, -apple-system, sans-serif',
            padding: '10px',
            '--img-size': `${imageSize}px`
        }}>
            {!showLoaded && (
                <style>{`
          .row-success {
            display: none !important;
          }
        `}</style>
            )}

            {/* Control Dashboard */}
            <div style={{
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
                background: '#ffffff',
                padding: '16px 20px',
                borderRadius: '10px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                border: '1px solid #e2e8f0'
            }}>
                <button
                    onClick={() => setShowLoaded(!showLoaded)}
                    style={{
                        padding: '10px 18px',
                        backgroundColor: showLoaded ? '#ffffff' : '#ebf8ff',
                        color: showLoaded ? '#4a5568' : '#2b6cb0',
                        border: `1px solid ${showLoaded ? '#cbd5e0' : '#bee3f8'}`,
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        transition: 'all 0.2s'
                    }}
                >
                    {showLoaded ? '👁️ Erfolgreiche Zeilen ausblenden' : '👁️ Alle Zeilen anzeigen'}
                </button>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', color: '#4a5568' }}>
                    <label htmlFor="size-slider" style={{ fontWeight: '500' }}>Bildgröße:</label>
                    <input
                        id="size-slider"
                        type="range"
                        min="50"
                        max="400"
                        value={imageSize}
                        onChange={(e) => setImageSize(Number(e.target.value))}
                        style={{ cursor: 'pointer', accentColor: '#2b6cb0', verticalAlign: 'middle' }}
                    />
                    <span style={{ minWidth: '45px', fontWeight: '600', color: '#1a202c' }}>{imageSize}px</span>
                </div>

          {/*      <div style={{ fontSize: '14px', fontFamily: 'sans-serif' }}>*/}
          {/*          <span>Produkte insgesamt: <strong>{products_de.length}</strong></span>*/}
          {/*          <span style={{ margin: '0 10px', color: '#ccc' }}>|</span>*/}
          {/*          <span style={{ color: 'red' }}>*/}
          {/*  Fehlende Primärbilder (❌): <strong>{failedItems.size}</strong>*/}
          {/*</span>*/}
          {/*      </div>*/}
                <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ fontSize: '14px', color: '#4a5568' }}>
                        Produkte insgesamt: <strong style={{ color: '#1a202c', fontSize: '16px' }}>{products_de.length}</strong>
                    </div>
                    <div style={{ width: '1px', height: '20px', backgroundColor: '#e2e8f0' }}></div>
                    <div style={{ fontSize: '14px', color: '#4a5568' }}>
                        Fehlende Primärbilder: <strong style={{ color: '#e53e3e', fontSize: '16px' }}>{failedItems.size}</strong>
                    </div>
                </div>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                <thead>
                <tr>
                    <th style={thStyle}>Artikelnummer</th>
                    <th style={thStyle}>Gtin</th>
                    <th style={thStyle}>Primäres Bild</th>
                    <th style={{ ...thStyle, textAlign: 'center' }}>Status</th>
                    <th style={thStyle}>Fallback Bild (JUNG)</th>
                </tr>
                </thead>
                <tbody>
                {products_de.map((p) => (
                    <ProductRow
                        key={p.Artikelnummer}
                        product={p}
                        onImageError={handleImageError}
                    />
                ))}
                </tbody>
            </table>
        </div>
    );
}

export function ProductRow({ product, onImageError }) {
    // Status states: 'loading', 'success', or 'error'
    const [imageStatus, setImageStatus] = useState('loading');

    const handleLoad = () => {
        setImageStatus('success');
    };

    const handleError = () => {
        setImageStatus('error');
        onImageError(product.Artikelnummer);
    };

    const rowClass = imageStatus === 'success' ? 'row-success' : '';

    // Generate the fallback URL string dynamically
    const fallbackUrl = 'https://www.jung-group.com/downloads/catalogue/images/800x800_png/JUNG_' + product.Artikelnummer + '.png';

    const cellStyle = {
        padding: '14px 16px',
        verticalAlign: 'middle',
        borderBottom: '1px solid #edf2f7',
        color: '#2d3748',
        fontSize: '14px',
    };

    const imageStyle = {
        width: 'var(--img-size)',       // Handles dynamic sliding scaling
        maxWidth: 'var(--img-size)',    // Strict constraints matching choice
        height: 'var(--img-size)',
        maxHeight: 'var(--img-size)',
        borderRadius: '6px',
        objectFit: 'contain',
        boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
        backgroundColor: '#fff',
        border: '1px solid #e2e8f0',
        display: 'block',
        transition: 'width 0.05s ease, height 0.05s ease' // Smooth scaling glide
    };

    return (
        <tr className={rowClass} style={{ transition: 'background-color 0.2s' }}>
            <td style={{ ...cellStyle, fontWeight: '600', color: '#1a202c' }}>{product.Artikelnummer}</td>
            <td style={cellStyle}>{product.Gtin}</td>

            {/* Primary Image Column */}
            <td style={{ ...cellStyle, textAlign: 'center' }}>
                <img
                    src={GenerateImagePath.getPath(product.Gtin, "")}
                    alt=""
                    loading="lazy"
                    style={{ ...imageStyle }}
                    onLoad={handleLoad}
                    onError={handleError}
                />
            </td>

            {/* Status Verification Column */}
            <td style={{ ...cellStyle, textAlign: 'center', fontSize: '20px' }}>
                {imageStatus === 'loading' && <span>⏳</span>}
                {imageStatus === 'success' && <span style={{ color: 'green' }}>✔️</span>}
                {imageStatus === 'error' && <span style={{ color: 'red', fontWeight: 'bold' }}>❌</span>}
            </td>

            {/* New Fallback Image Column */}
            <td style={cellStyle}>
                {imageStatus === 'error' ? (
                    <img
                        src={fallbackUrl}
                        alt="Fallback"
                        loading="lazy"
                        style={{ ...imageStyle, border: "1px dashed #ccc" }}
                    />
                ) : (
                    <span style={{ color: '#aaa', fontSize: '13px' }}>—</span>
                )}
            </td>
        </tr>
    );
}
